
import { defineComponent, onBeforeMount, PropType } from 'vue'
import IconPath from '@/assets/icons/path.svg'
import IconPie from '@/assets/icons/pie.svg'

type ViewValue = 'sector' | 'direction'

export default defineComponent({
    components: {
        IconPath,
        IconPie,
    },
    props: {
        value: {
            type: String as PropType<ViewValue>,
            default: 'sector',
        },
    },
    emits: ['update:value'],
    setup(props, { emit }) {
        const initializeValue = () => {
            const savedView = localStorage.getItem('bpms-view-manager-value')

            if (savedView) {
                emit('update:value', savedView)
            }
        }

        const changeView = (view: ViewValue) => {
            if (view === props.value) {
                return
            }

            localStorage.setItem('bpms-view-manager-value', view)
            emit('update:value', view)
        }

        onBeforeMount(initializeValue)

        return {
            changeView,
        }
    },
})
